
import { defineComponent } from "vue";

export default defineComponent({
  name: "loader-spinner",
  props: ["show"],
  computed: {
    is_show() {
      return this.show ?? false;
    },
  },
});
